<template lang="html">
  <div class="cs-page">
    <!-- <h1>{{store.currentcase}}</h1>s -->
    <cs-hero>
      <img slot="hero-image" :src="currentCase.hero" :alt="currentCase.title">
    </cs-hero>

    <div class="cs-internal">
      <span></span>

      <header class="cs__title">
        <div>
          <h3>{{ currentCase.title }}</h3>
          <h4>{{ currentCase.client }}</h4>
        </div>
      </header>

      <div class="cs__logo">
        <img :src="currentCase.logo">
      </div>

      <article class="s-cs__desc">
        <span class="notch notch--sm notch--red"></span>
        <div v-html="currentCase.body"></div>
      </article>

      <section class="s-gallery">
        <h4>Gallery</h4>
        <ul class="cs__gallery">
          <li v-for="image in currentCase.images"
            :key="image.id"
            @click="lightbox(image.id)"
          >
            <img :src="image.image">
            <div class="cs__gallery-img">
              <div>
                <img src="/static/svg/eye.svg" alt="">
              </div>
            </div>
            <div class="cs__lightbox-bg"
                v-if="isActive === image.id"
                @click.stop="isActive = false"
            >
              <div class="cs__lightbox">
                <img
                  :src="image.image"
                  @click.stop="isActive = false">
              </div>
            </div>
          </li>
        </ul>
      </section>

      <span></span>
      <aside></aside>
    </div>
    <contact></contact>
    <main-footer></main-footer>
  </div>
</template>

<script>
  // import { CASE } from '@/store/mutation-types'
  import { mapGetters } from 'vuex'
  import CsHero from '@/components/CsHero'
  import CsInternal from '@/components/CsInternal'
  import CsGallery from '@/components/CsGallery'
  import Contact from '@/components/Contact'
  import Footer from '@/components/Footer'

  export default {
    components: {
      'cs-hero': CsHero,
      'cs-internal': CsInternal,
      'cs-gallery': CsGallery,
      'contact': Contact,
      'main-footer': Footer
    },
    name: 'cs',
    data () {
      return {
        isActive: false
      }
    },
    computed: {
      ...mapGetters([
        'currentCase'
      ])
    },
    methods: {
      lightbox (id) {
        this.isActive = id
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .cs-internal {
    display: grid;
    grid-template-columns: 1rem minmax(auto, 60rem) 7.500rem 1fr 1.001rem;
    grid-template-rows: 7.500rem auto auto;
    @include breakpoint($md) {
      grid-template-columns: 9.375rem minmax(auto, 60rem) 7.500rem 1fr 9.375rem;
    }

    > span:nth-of-type(1) {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      background-color: $dark-blue;
    }

    > span:nth-of-type(2) {
      grid-column: 4 / 6;
      grid-row: 1 / 2;
      background-color: $light-red;
    }

    > aside {
      grid-column: 4 / 6;
      grid-row: 2 / 5;
      background-image: linear-gradient(to top, $light-blue, $dark-blue);
    }
  }

  .s-cs__desc {
    grid-column: 2 / 4;
    grid-row: 2 / 3;
    padding-top: 7.500rem;
    padding-right: 1rem;
    @include breakpoint($md) {
      grid-column: 2 / 3;
    }
  }

  .cs__title {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
    display: flex;
    align-items: center;
    // padding-left: 9.375rem;
    background-color: $dark-blue;
    color: white;
    h3 {
      margin: 0;
      font-family: $barlowCondensed;
      font-size: 2rem;
      font-weight: 300;
      line-height: 1.2;
      @include breakpoint($md) {
        font-size: 3rem;
      }
    }
    h4 {
      margin: 0;
      font-family: $montserrat;
      font-size: 0.8rem;
      font-weight: 500;
      line-height: 1.5;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: $light-blue;
      @include breakpoint($md) {
        font-size: 1.125rem;
      }
    }
  }

  .cs__logo {
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    img {
      width: 100%;
      height: auto;
    }
  }

  .s-gallery {
    grid-column: 2 / 5;
    grid-row: 3 / 4;
    margin-bottom: 10rem;
    z-index: 10;
    h4 {
      font-family: $barlowCondensed;
      font-size: 1.875rem;
      font-weight: 700;
      color: $dark-blue;
    }
  }

  .cs__gallery {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(18.687rem, 1fr));
    grid-auto-rows: minmax(auto, 18.687rem);
    grid-gap: 0.063rem;
    list-style-type: none;
    margin: 0;
    padding: 0;
    background-color: $white;
    padding: 1rem 1rem 1rem 0;
    > li {
      position: relative;
      overflow: hidden;
      &:hover {
        > img {
          transform: scale(1.1);
        }
      }
      > img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
        object-position: 50% 50%;
        transition: 0.3s ease;
      }
    }
  }

  .cs__gallery-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.5rem;
    color: $white;
    transition: background 0.3s ease;
    &:hover {
      background-color: rgba($dark-red, 0.5);
      cursor: pointer;
      > div {
        display: flex;
      }
    }
    > div {
      display: none;
      justify-content: center;
      align-items: center;
      border: 1px solid $white;
      border-radius: 100%;
      height: 5.625rem;
      width: 5.625rem;
    }
  }

  .cs__lightbox {
    position: relative;
    max-width: 50rem;
    margin: 0 1rem;
    // box-shadow: 0px 3px 25px 5px rgba($black, 0.3);
    img {
      width: 100%;
      vertical-align: middle;
      height: auto;
    }
  }

  .cs__lightbox-bg {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba($dark-blue, 0.9);
    z-index: 100;
  }
</style>




// WEBPACK FOOTER //
// src/components/CaseStudy.vue